export const GENDER_MALE = 'M'
export const GENDER_FEMALE = 'F'
export const GENDER_UNKNOWN = 'U'
export type Gender = 'M' | 'F' | 'U'
export const GenderMapping = {
  GENDER_MALE,
  GENDER_FEMALE,
  GENDER_UNKNOWN
}



// WEBPACK FOOTER //
// ./src/types/gender.js